module.exports = __webpack_public_path__ + "static/media/HRVT_1.719f9724.jpg";